module.exports = __webpack_public_path__ + "img/avax-c.f826cfa7.svg";